import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { ApiKeysService } from 'app/API';

type TProps = {
  id: string;
  organizationId: string;
  onCancel: () => void;
  onSuccess: () => void;
};

export const DeleteAPIKeyModal = ({ id, organizationId, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();

  const handleDeleteAPIKey = async () => {
    await call(ApiKeysService.remove({ organizationId: organizationId, apiKeyId: id }));
    onSuccess();
  };

  return (
    <ModalWrapper width="400px">
      <ModalTitle>Confirm</ModalTitle>
      <p className="m-0 text-center">Are you sure you want to delete this API Key?</p>
      <form>
        <div className="mx-auto flex justify-center w-[300px] gap-2.5">
          <OutlinedButton type="button" onClick={onCancel}>
            Cancel
          </OutlinedButton>
          <Button type="button" onClick={handleDeleteAPIKey}>
            Delete
          </Button>
        </div>
      </form>
    </ModalWrapper>
  );
};
